export const antiFraudConstants = {
	GENERATE_SESSION_ID: 'GENERATE_SESSION_ID'
}
